// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-product-modal-modal_card-BrnLw {
  width: 340px;
  height: auto;
}

.edit-product-modal-textField_container-HpgLZ, .edit-product-modal-select_container-FfMsA {
  width: 100%;
  margin-top: 24px;
}

.edit-product-modal-product-qiZ5d {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
}

.edit-product-modal-productLabel-rbppj {
  font-size: 14px;
  color: var(--color-neutral-800);
}

.edit-product-modal-productContent-gBrnD {
  display: flex;
  align-items: center;
  gap: 12px;
}

.edit-product-modal-productImage-Q0jU2 {
  width: 28px;
  height: 28px;
}

.edit-product-modal-productName-JkFWv {
  font-size: 16px;
  color: var(--color-neutral-900);
}
`, "",{"version":3,"sources":["webpack://./src/pages/customer/products/edit-product-modal/edit-product-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC","sourcesContent":[".modal_card {\n  width: 340px;\n  height: auto;\n}\n\n.textField_container, .select_container {\n  width: 100%;\n  margin-top: 24px;\n}\n\n.product {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.productLabel {\n  font-size: 14px;\n  color: var(--color-neutral-800);\n}\n\n.productContent {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.productImage {\n  width: 28px;\n  height: 28px;\n}\n\n.productName {\n  font-size: 16px;\n  color: var(--color-neutral-900);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `edit-product-modal-modal_card-BrnLw`,
	"textField_container": `edit-product-modal-textField_container-HpgLZ`,
	"select_container": `edit-product-modal-select_container-FfMsA`,
	"product": `edit-product-modal-product-qiZ5d`,
	"productLabel": `edit-product-modal-productLabel-rbppj`,
	"productContent": `edit-product-modal-productContent-gBrnD`,
	"productImage": `edit-product-modal-productImage-Q0jU2`,
	"productName": `edit-product-modal-productName-JkFWv`
};
export default ___CSS_LOADER_EXPORT___;
